/**
 *  Actions that can be executed with a PDF
 */
export enum PdfActionEnum {
  print,
  download
}
